import { render, staticRenderFns } from "./update-solo-parent-form.vue?vue&type=template&id=16f8ced3&"
import script from "./update-solo-parent-form.vue?vue&type=script&lang=js&"
export * from "./update-solo-parent-form.vue?vue&type=script&lang=js&"
import style0 from "./update-solo-parent-form.vue?vue&type=style&index=0&id=16f8ced3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports